import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { supabaseClient } from "../utils/supabase";
import type { DayStats } from "../utils/studyTrackerHelpers";

export interface StudyTrackerData {
    days: DayStats[];
    allStudyNumbers: number[];
}

export function useStudyTrackerData(options?: Omit<UseQueryOptions<StudyTrackerData>, "queryKey" | "queryFn">) {
    return useQuery({
        queryKey: ["study-tracker"],
        queryFn: async (): Promise<StudyTrackerData> => {
            const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;

            if (!supabaseUrl) {
                throw new Error("Supabase URL not configured");
            }

            // Call Edge Function to get study tracker data
            const { data, error } = await supabaseClient.functions.invoke("study-tracker");

            if (error) {
                console.error("Failed to fetch study tracker data:", error);
                throw error;
            }

            if (data && typeof data === "object" && "days" in data) {
                return data as StudyTrackerData;
            }

            throw new Error("Invalid response from study-tracker function");
        },
        staleTime: 1000 * 60, // 1 minute
        refetchInterval: 1000 * 60 * 5, // Refetch every 5 minutes
        ...options,
    });
}
